import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Button } from './elements';
import { ReactComponent as ArrowUp } from './arrowUp.svg';

interface ScrollTopProps {
  scrollStepInPx: string;
  delayInMs: string;
}

const height = 50;
const velocity = 0.15;

const scrollToTop = () => {
  if (!window.requestAnimationFrame) {
    window.scrollTo(0, 0);
    return;
  }
  let start: number | null = null;
  let animationRequest: number | null = null;
  const pageYOffset = window.pageYOffset;
  const cancelAnimation = () => {
    if (animationRequest && window.cancelAnimationFrame) window.cancelAnimationFrame(animationRequest);
    document.removeEventListener('wheel', cancelAnimation);
    document.removeEventListener('touchstart', cancelAnimation);
  };
  const step = (time: number) => {
    if (start === null) start = time;
    const nextPageOffset = Math.max(0, pageYOffset - (time - start) / velocity);
    window.scrollTo(0, nextPageOffset);
    if (nextPageOffset !== 0) return (animationRequest = requestAnimationFrame(step));
    animationRequest = null;
    cancelAnimation();
  };
  animationRequest = requestAnimationFrame(step);
  document.addEventListener('wheel', cancelAnimation);
  document.addEventListener('touchstart', cancelAnimation);
};

const ScrollTop = (props: ScrollTopProps): JSX.Element => {
  const buttonRef = useRef<HTMLDivElement>(null);
  const pageOffset = useRef<number>(0);
  const [buttonOpacityState, setButtonOpacityState] = useState(0);

  const handleScroll = useCallback(() => {
    const pageYOffset = window.pageYOffset;
    const offset = pageOffset.current - pageYOffset;
    pageOffset.current = pageYOffset;

    if (offset > 0 && pageYOffset < 50) {
      return setButtonOpacityState(Math.max(0, (pageYOffset - 20) / 30));
    }
    if (offset < 0 && buttonOpacityState > 0) {
      return setButtonOpacityState(Math.max(0, buttonOpacityState - -offset / height));
    }
    if (offset > 0 && buttonOpacityState < 1) {
      return setButtonOpacityState(Math.min(1, offset / height + buttonOpacityState));
    }
  }, [buttonOpacityState, setButtonOpacityState]);

  useEffect(() => {
    if (!buttonRef.current) return;
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  });

  return (
    <Button
      ref={buttonRef}
      style={{
        opacity: buttonOpacityState,
        visibility: buttonOpacityState ? 'visible' : 'hidden',
      }}
      onClick={scrollToTop}
    >
      <ArrowUp />
    </Button>
  );
};
export default ScrollTop;
